import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ArborescenceProjets from './ArborescenceProjets/ArborescenceProjets';
import * as actions from '../../../services/actions';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import '../../../../node_modules/react-simple-tree-menu/dist/main.css';
import { CgListTree } from 'react-icons/cg';
import { RiPushpinFill, RiPushpin2Fill } from 'react-icons/ri';
import { BiSearch, MdClose } from 'react-icons/all';
import Bouton from '../../UI/Bouton/Bouton';
import styles from './RubriquesNavigationClient.module.scss';

const sortByProjectName = (list) => {
  return list.sort((a, b) => {
    const nameA = a.project_name.toUpperCase();
    const nameB = b.project_name.toUpperCase();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  });
};

const RubriquesNavigationClient = () => {
  const [afficherBarreDeRecherche, setAfficherBarreDeRecherche] =
    useState(false);

  const dispatch = useDispatch();
  const listeFavoris = useSelector(
    (state) => state.authentifie.favorite_projects_list_id
  );
  const listeProjets = useSelector((state) => state.authentifie.projects_list);

  const project_id_url = useSelector(
    (state) => state.interfaceClient.project_id_url
  );

  useEffect(() => {
    dispatch(actions.reqRecupererListeTableauxDeBordFavoris());
  }, [dispatch]);

  const enregistrementProjectIdUrl = (project_id) => {
    dispatch(actions.enregistrerProjectIdUrl(project_id));
  };

  const gererAfficherBarreDeRecherche = (etat) => {
    setAfficherBarreDeRecherche(etat);
  };

  let projets_favoris_liste = [];
  if (listeProjets && listeFavoris) {
    projets_favoris_liste = listeProjets.filter((projet) =>
      listeFavoris.includes(projet.project_id)
    );
    projets_favoris_liste = sortByProjectName(projets_favoris_liste);
  }

  return (
    <ul className={[styles.RubriquesNavigation].join(' ')}>
      {/* <li className={styles.LiTitre} key={'favoris_general'}>
        <span className={styles.mark}>{checkMot('projet_favoris')}</span>
        <RiPushpin2Fill size={15} className={styles.btstyle} />
      </li> */}
{/* 
      {Object.keys(projets_favoris_liste).map((favorisKey) => (
        <span className={styles.LiensFavoris} key={'favorisKey' + favorisKey}>
          <span className={styles.facIco}>
            <RiPushpinFill size={14} color={'#eeb214'} />{' '}
          </span>
          <span className={styles.Lienfav}>
            <Link
              to={'/' + projets_favoris_liste[favorisKey].project_id}
              className={styles.bouton_favoris}
              onClick={() =>
                enregistrementProjectIdUrl(
                  projets_favoris_liste[favorisKey].project_id
                )
              }
            >
              <span
                className={
                  project_id_url ===
                  projets_favoris_liste[favorisKey].project_id
                    ? styles.bouton_favoris_actif
                    : styles.bouton_favoris
                }
              >
                {projets_favoris_liste[favorisKey].project_name}
              </span>
            </Link>
          </span>
        </span>
      ))} */}

      <li className={styles.LiTitre} key={'Arborescence des projets'}>
        <CgListTree size={15} className={styles.btstyle} />
        <span
          className={[styles.mark, styles.barre_recherche_arborescence].join(
            ' '
          )}
        >
          <div className={styles.texte_arborescence}>
            {checkMot('arborescence_des_projets')}
          </div>
          <Bouton
            ajoutClass={styles.bouton_recherche}
            cliquer={() =>
              gererAfficherBarreDeRecherche(!afficherBarreDeRecherche)
            }
          >
            {afficherBarreDeRecherche ? <MdClose /> : <BiSearch />}
          </Bouton>
        </span>
      </li>

      <ArborescenceProjets
        afficherBarreDeRecherche={afficherBarreDeRecherche}
      />
    </ul>
  );
};

export default RubriquesNavigationClient;
